import {
  Directive,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';
import type {
  OnInit
} from '@angular/core';

@Directive({
    selector: '[pplLink]',
    standalone: false
})
export class PplLinkDirective implements OnInit {
  @Input() pplLink: boolean;

  constructor(
    private elementRef: ElementRef,
    protected renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (this.pplLink !== false) {
      this.renderer.addClass(this.elementRef.nativeElement, 'ppl-link');
    }
  }
}
